// extracted by mini-css-extract-plugin
export var actions = "_tb-4";
export var item = "_tb-1";
export var price = "_tb-3";
export var quantity = "_tb-2";
export var table = "_tb-0";